import React, { useState } from 'react';
import { ROUTES } from 'constants/routes';
import { Routes, Route } from 'react-router-dom';
import Products from 'pages/Products';
import Resources from 'pages/Resources';
import MainLayout from 'Layout/main';
import AboutProducts from 'pages/AboutProduct';
import CropNutritionPrograms from 'pages/CropNutritionPrograms';
import TrialResults from 'pages/TrialResults';
import DetailedOfCropNutrition from 'pages/DetailedOfCropNutrition';
import DetailedTrialResults from 'pages/DetailedTrialResults';
import InformationMaterials from 'pages/InformationMaterials';
import AboutUs from 'pages/AboutUs';
import News from 'pages/News';
import Article from 'pages/Article';
import DetailedJob from 'pages/DetailedJob';
import Career from 'pages/Career';
import TermsAndConditions from 'pages/TermsAndConditions';
import LegalInfo from 'pages/LegalInfo';
import Contacts from 'pages/Contacts';
import Page404 from 'pages/Page404';
import { UIKit } from 'pages/UIKit/UIKit';
import { Homepage } from 'pages/Homepage/Homepage';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHomepage, selectHomepageIsLoading } from 'store/slices/HomepageSlice';
import { fetchMainProducts } from 'store/slices/ProductsSlice';
import { fetchTranslations, selectTranslationsIslLoading } from 'store/slices/GeneralTranslationsSlice';
import { fetchLanguages, fetchCountries } from 'store/slices/languageSlice';
import Preloader from 'Layout/Preloader';
import { fetchLatestPostsForHomepage } from 'store/slices/BlogSlice';
import { homepage_posts_limit } from 'api/constants';

const App = () => {
    const dispatch = useDispatch();
    const homepageIsLoading = useSelector(selectHomepageIsLoading);
    const translationsIslLoading = useSelector(selectTranslationsIslLoading);
    const [loading, setLoading] = useState(true);

    const start = async () => {
        // @ts-ignore
        await dispatch(fetchLanguages());
        // @ts-ignore
        await dispatch(fetchCountries());
        // @ts-ignore
        await dispatch(fetchTranslations());
        // @ts-ignore
        dispatch(fetchLatestPostsForHomepage({ limit: homepage_posts_limit }));
        // @ts-ignore
        dispatch(fetchMainProducts());
        // @ts-ignore
        dispatch(fetchHomepage());

        setLoading(false);
    };
    React.useEffect(() => {
        start();
    }, [dispatch]);

    if (translationsIslLoading || homepageIsLoading || loading) {
        return <Preloader />;
    }

    return (
        <>
            <Routes>
                <Route path="/ui-kit" element={<UIKit />} />
                <Route path={ROUTES.base} element={<MainLayout />}>
                    <Route path={ROUTES.base} element={<Homepage />} />
                    <Route path={ROUTES.products} element={<Products />} />
                    <Route path={ROUTES.products + '/:slug'} element={<AboutProducts />} />
                    <Route path={ROUTES.resources} element={<Resources />} />
                    <Route path={ROUTES.trialResults} element={<TrialResults />} />
                    <Route path={ROUTES.trialResults + '/:slug'} element={<DetailedTrialResults />} />
                    <Route path={ROUTES.cropNutritionPrograms} element={<CropNutritionPrograms />} />
                    <Route path={ROUTES.cropNutritionPrograms + '/:slug'} element={<DetailedOfCropNutrition />} />
                    <Route path={ROUTES.informationMaterials} element={<InformationMaterials />} />
                    <Route path={ROUTES.aboutUs} element={<AboutUs />} />
                    <Route path={ROUTES.news} element={<News />} />
                    <Route path={ROUTES.news + '/:slug'} element={<Article />} />
                    <Route path={ROUTES.article} element={<Article />} />
                    <Route path={ROUTES.career} element={<Career />} />
                    <Route path={ROUTES.career + '/:slug'} element={<DetailedJob />} />
                    <Route path={ROUTES.termsAndConditions} element={<TermsAndConditions />} />
                    <Route path={ROUTES.legalInfo} element={<LegalInfo />} />
                    <Route path={ROUTES.contacts} element={<Contacts />} />
                    <Route path="*" element={<Page404 />} />
                </Route>
            </Routes>
        </>
    );
};

export default App;
